import script from "./TagFilterSelect.vue?vue&type=script&setup=true&lang=js"
export * from "./TagFilterSelect.vue?vue&type=script&setup=true&lang=js"

import "./TagFilterSelect.vue?vue&type=style&index=0&id=8694d960&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-8694d960"]])

export default __exports__